import React, { useContext } from "react";
import { PetType } from "../../types";
import { FilterContext } from "../FilterProvider";

export const PetFilter = ({ petType }: { petType: PetType }) => {
  const { filterValue, setFilterValue } = useContext(FilterContext);

  const isActive = () => petType === filterValue;

  const handleOnClick = () => {
    isActive() ? setFilterValue("") : setFilterValue(petType);
  };

  const filterClassName = "pet-filter";
  const filterClassNameSelection = isActive()
    ? `${filterClassName} ${filterClassName}--checked`
    : filterClassName;

  return (
    <div onClick={handleOnClick} className={filterClassNameSelection}>
      show only {petType}
    </div>
  );
};
